import React, {Fragment, useState} from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import {Container, Row, Col} from '../../../../shared-ui/components/ui/wrapper'
import Heading from '../../../../shared-ui/components/ui/heading'
import Text from '../../../../shared-ui/components/ui/text'
import Button from '../../../../shared-ui/components/ui/button'
//import ModalVideo from '../../../../shared-ui/components/ui/modal-video'
import {HeroWrapper, HeroContent, HeroBtnGroup, HeroSeparator} from './index.style'
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge" // Bridget between the old Gatsby Image and the new one.

const HeroSection = ({title, subtitle, text, bgImage, callToActionText, callToActionPath, ...props }) => {     
//const HeroSection = (title, subtitle, text, bgImage, callToActionText, callToActionPath, ...props ) => {
        
    // The BackgroundImage component is still using the old way for referencing images
    // so, something had to be done to convert it to suppor the new way to reference images.
    // This in particular dropped the support for "fluid" images.
    // This documentation helped to made this conversion
    // https://www.gatsbyjs.com/plugins/gatsby-background-image/
    // https://github.com/timhagn/gatsby-background-image/tree/main/packages/gbimage-bridge 
    // https://www.gatsbyjs.com/docs/reference/release-notes/image-migration-guide/
    //const image = getImage(bgImage);
    //const bgImageConverted = convertToBgImage(image);
    
    const {subtitleStyle, titleStyle, textStyle, btnStyle, consult_btn, work_btn} = props;
    //const {bg_image, link, video_link} = heroData.indexResolutionsJson;    
    /*
    const {bg_image, link, video_link} = heroData.indexResolutionsJson;    
    let video_arr, video_id, video_channel;
    if(video_link){
        video_arr = video_link.split('=', -1);
        video_id = video_arr[1];
        video_channel = video_link.split(".")[1];
    }
    const [videoOpen, setVideoOpen] = useState(false);
    const modalVideoOpen = () => {
        setVideoOpen(true)
    }
    const modalVideoClose = () => {
        setVideoOpen(false)
    }*/
    return (
        <Fragment>
            <HeroWrapper fluid={bgImage} >                
                <Container>
                    <Row>
                        <Col lg={12}>
                            <HeroContent>
                                {subtitle && <Heading {...subtitleStyle}>{subtitle}</Heading>}
                                {title && <Heading {...titleStyle}>{title}</Heading>}
                                {text && <Text {...textStyle}>{text}</Text>}
                                <HeroBtnGroup>
                                    {callToActionText && <Button to={callToActionPath} {...btnStyle} {...consult_btn}>{callToActionText}</Button>}
                                    {/*video_link && <Button onClick={modalVideoOpen} icon="fa fa-play" {...btnStyle} {...work_btn}>How We Work</Button>*/}
                                </HeroBtnGroup>
                            </HeroContent>
                        </Col>
                    </Row>
                </Container>
                <HeroSeparator>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 100 100">
                        <path d="M 0 0 L0 100 L100 100 L100 0 Q 50 200 0 0"></path>
                    </svg>
                </HeroSeparator>
            </HeroWrapper>
            {/*<ModalVideo
                channel={video_channel}
                videoId={video_id}
                isOpen={videoOpen}
                onClose={modalVideoClose}
            />*/}
        </Fragment>
    )
}

HeroSection.defaultProps = {
    subtitleStyle: {
        as: 'h3',
        color: '#fff',
        mb: '20px',        
        responsive: {
            large: {
                fontSize: '30px'
            },
            small: {
                fontSize: '22px'
            }
        }
    },
    titleStyle: {
        as: 'h1',
        fontSize: '120px',
        color: '#fff',
        lineHeight: 1.09,
        mb: '30px',
        responsive: {
            xlarge: {
                fontSize: '100px'
            },
            large: {
                fontSize: '80px'
            },
            medium: {
                fontSize: '60px'
            },
            small: {
                fontSize: '50px'
            },
            xsmall: {
                fontSize: '40px',
                mb: '20px'
            }
        }
    },
    textStyle: {
        color: '#fff',
        fontWeight: 500
    },
    btnStyle: {
        m: '10px',
        fontSize: '14px'
    },
    consult_btn: {
        hover: "2"
    },
    work_btn: {
        skin: "light",
        color: "primary",
        iconposition: "left",
        display: "inline-flex",
        alignitems: "center",
        icondistance: "8px"
    }
}

export default HeroSection
